import { customerBankAccountState } from '../../model/details/bankAccountState';

// Types
import { LeadDetailRawType } from '../../types/Lead';

export default function transformBankAccountState(data: LeadDetailRawType) {
    const map = new Map();
    let _transform = {};

    map.set('customer.iban', 'iban');
    map.set('customer.bic', 'bic');
    map.set('customer.bankAccountOwner', 'bankAccountOwner');
    map.set('customer.bankName', 'bankName');

    map.forEach((uiKey, apiKey) => {
        const [type, subKey] = apiKey.split('.');
        const _v = subKey && data[type] ? data[type][subKey] : data[apiKey];

        _transform = {
            ..._transform,
            [uiKey]: _v === null || _v === undefined ? customerBankAccountState[uiKey] : _v,
        };
    });

    return _transform;
}
